module.exports = __webpack_public_path__ + "static/media/patio.cffa025c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/patio.jpg
 ** module id = 695
 ** module chunks = 0
 **/